<template lang="pug">
  Modal.view-partner-cdn-headers(title="CDN Headers", v-bind="$attrs", size="is-wide")
    div.loading(v-if="loading")
      Icon(icon="spinner", spin, class="text-2xl text-gray-500")
      span.ml-2.text-gray-600 Loading headers&hellip;
    dl.dl-horizontal(v-else)
      template(v-for="header in cdnHeaders")
        dt {{ header.name }}
        dd {{ header.value }}
</template>

<script>
export default {
  props: {
    partnerId: Number,
    siteId: Number
  },
  data: () => ({
    loading: true,
    cdnHeaders: []
  }),
  created() {
    this.loading = true
    this.$api.get(`partners/${this.partnerId}/sites/${this.siteId}/cdn-headers`).then(response => {
      this.cdnHeaders = Array.isArray(response.data) ? response.data : []
      this.loading = false
    })
  }
}
</script>

<style>
.modal.view-partner-cdn-headers {
  width: auto;
  max-width: 80vw;

  .modal-body {
    @apply mt-12 border-t p-0;
  }

  .loading {
    @apply flex flex-col items-center justify-center gap-4 p-8;
  }
}
</style>
